// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"Paragraph_paragraph__gus_m","waveAnimation":"Paragraph_waveAnimation__wMh2Z","marquee":"Paragraph_marquee__di9qW"};